import i18next from 'core/i18n';

import { palettes } from '@indigo-ag/component-module';
import {
  AgFinancingPhase2Status,
  AgFinancingPhase3Status,
  AgFinancingPhaseStatus,
  CprStatus,
  PendencyStatus
} from '@indigo-ag/schema';

export type StatusIndicatorAvailableStatus =
  | AgFinancingPhaseStatus
  | AgFinancingPhase2Status
  | PendencyStatus
  | CprStatus
  | AgFinancingPhase3Status;

export const generateColorAndTextIndicator = (
  status: StatusIndicatorAvailableStatus
): { color: string; text: string } => {
  switch (status) {
    // Approved
    case AgFinancingPhase2Status.APPROVED:
    case CprStatus.APPROVED:
    case PendencyStatus.APPROVED:
    case AgFinancingPhaseStatus.CLEAR:
    case AgFinancingPhase3Status.APPROVED:
      return {
        color: palettes.legacy.green.default,
        text: i18next.t('approved')
      };

    // Denied
    case AgFinancingPhase2Status.DENIED:
    case CprStatus.DENIED:
    case PendencyStatus.DENIED:
    case AgFinancingPhaseStatus.DENIED:
    case AgFinancingPhase3Status.DENIED:
      return {
        color: palettes.coastal.accent.red,
        text: i18next.t('phaseDenied')
      };

    // Pending - In Progress
    case AgFinancingPhase2Status.IN_PROGRESS:
    case PendencyStatus.PENDING:
    case AgFinancingPhase3Status.IN_PROGRESS:
      return {
        color: palettes.coastal.accent.yellow,
        text: i18next.t('inProgress')
      };

    case CprStatus.ON_HOLD:
      return {
        color: palettes.coastal.accent.yellow,
        text: i18next.t('waiting')
      };

    case CprStatus.SENT_BACK_FOR_REVISION:
      return {
        color: palettes.coastal.accent.yellow,
        text: i18next.t('sentBackForRevision')
      };

    case AgFinancingPhase2Status.WAITING_COMMITTEE_DECISION:
      return {
        color: palettes.coastal.accent.yellow,
        text: i18next.t('waitingCommittee')
      };

    case AgFinancingPhase2Status.PENDING_ACTIVATION:
      return {
        color: palettes.neutral['500'],
        text: i18next.t('creditAnalysisPendingPillTitle')
      };

    // NOT STARTED
    default:
      return {
        color: palettes.neutral['500'],
        text: i18next.t('notStarted')
      };
  }
};
